// import { configureStore } from "@reduxjs/toolkit";
// import rootReducer from "./rootReducer";
// const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefalutMiddleware) => {
//     return getDefalutMiddleware({
//       serializableCheck: false,
//     });
//   },
// });
// export default store;



import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import rootReducer from "./rootReducer";

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["district"], // ✅ add slices you want persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefalutMiddleware) =>
    getDefalutMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
